var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};



//////////////////
// WEBPACK FOOTER
// /home/svc.teamcity.prd/BuildAgent/work/80562bb639a6ae70/node_modules/core-js/modules/_a-number-value.js
// module id = mnRY
// module chunks = 8